export default "__VITE_ASSET__CAsvjGEp__"